import { createExportExcelService } from "app/pages/sales-intelligence/common-components/table-actions-panel";

export const exportAppsToExcelService = createExportExcelService("apps");
